import axios from 'axios';
import { useEffect, useState } from 'react';
import Preloader from '../../components/Preloader';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import usePage from '../../framework/hooks/usePageHook';
import PageHeader from '../../components/header/PageHeader';
import useApiUrl from '../../framework/hooks/useApiUrlHook';

export default function ServiceOverview({ page }) {
    const pageObj = usePage(page.id);
    const apiUrl = useApiUrl();
    const [services, setServices] = useState([]);

    const getServices = () => {
        axios
            .get(`${apiUrl}/service/all`)
            .then((response) => {
                setServices(response.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        if (apiUrl != null) getServices();
    }, [apiUrl]);

    if (!page) return <Preloader />;

    return (
        <>
            <Navigation page={page} />
            <PageHeader title={page.paginatitel} description={page.inhoud} />
            <div className="container">
                <div className="row my-5">
                    <div className="col-xl-12 aos-init aos-animate">
                        {services?.map((service) => (
                            <a
                                key={service.id}
                                className="s-service-card"
                                href={`/onze-diensten/${service.url}`}
                                data-aos="fade-up"
                                data-aos-duration={1000}
                            >
                                <div className="card-icon">
                                    <img
                                        src={`${apiUrl}/img/extern/ratio/www.bandwerk.nl/dienst_categorie/orig/768/768/100/${service.image}`}
                                        alt="icons"
                                    />
                                </div>
                                <div className="title">
                                    <h1>{service.titel}</h1>
                                </div>
                                <div className="description" dangerouslySetInnerHTML={{ __html: service.desc }} />
                                <div className="read-more">
                                    Meer lezen
                                    <img src="/assets/img/icons/arrow-right-w.svg" alt="icon" />
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}
